<template>
  <ed-modal :show="showModal"
            :title="title"
            type="medium" flat
            @close="handleClose">
    <div class="content" slot="body">
      <itemsList :list="list.length > 1 ? filteredList : list" :programLabel="programLabel" />

      <div class="row bottom-row">
        <div class="row form-group col-md-7" v-if="atLeastOneItemIsInvoice">
          <label><strong>{{approvalNoteLabel}} <span v-if="!isReasonRequired">- optional</span></strong></label>
          <br />
          <div v-if="isReasonRequired">
            <em><small>Please add a note confirming that goods and services were received</small></em>
            <br />
          </div>
          <ed-textarea v-model="reason"
                       :max-length="1000"
                       :rows="4"
                       @input="onApprovalNoteChange"
                       :error='reasonError'
                       :errorTipBody="reasonErrorMsg"
                       errorTipHeader="" />
        </div>

        <userInfo v-if="isFirstItemFundsRequest(list[0]) && list.length === 1" title="Your Approval" />
        <userInfo v-if="list.length > 1" title="Your Approval" />

        <div class="request-funds-approve-container col-md-12">
          <ed-notice v-if="!isFirstItemFundsRequest(list[0]) && list.length === 1"
                     class="request-funds-validation"
                     type="danger"
                     message="There are insufficient funds in the account to complete this request."
                     icon="fas fa-exclamation-triangle" />
        </div>
      </div>
    </div>

    <div v-if="isFirstItemFundsRequest(list[0]) && list.length === 1" class="buttons clear" slot="footer">
      <ed-button button-class="btn btn-default" @click="handleClose" :disabled="loading">Cancel</ed-button>
      <ed-button :endpoint="getEndpoint()" @click="approve" :disabled="loading">Approve</ed-button>
    </div>
    <div v-if="list.length > 1" class="buttons clear" slot="footer">
      <ed-button button-class="btn btn-default" @click="handleClose" :disabled="loading">Cancel</ed-button>
      <ed-button :endpoint="getEndpoint()" @click="approve" :disabled="loading">Approve</ed-button>
    </div>
    <div v-if="!isFirstItemFundsRequest(list[0]) && list.length === 1" class="buttons clear" slot="footer">
      <ed-button button-class="btn btn-default" @click="$emit('close')">Close</ed-button>
    </div>
  </ed-modal>
</template>

<script>
  import itemsList from './items-list'
  import userInfo from './user-info'

  export default {
    props: {
      showModal: Boolean,
      list: Array,
      programLabel: String,
      cardApproval: Boolean,
      envelopeApproval: Boolean,
      submitEndpoint: String,
      loading: {
        type: Boolean,
        default: false
      }
    },

    data() {
      return {
        reason: '',
        reasonError: false
      }
    },

    computed: {
      title() { return (this.list.length === 1) ? 'You are about to approve this item' : 'You are about to approve these items' },

      approvalNoteLabel() {
        return this.list && this.list[0] ? this.list[0].ApprovalNoteLabel : 'Approval Note'
      },

      reasonErrorMsg() {
        return 'Please enter the ' + this.approvalNoteLabel
      },

      isReasonRequired() {
        return this.list && this.list[0] && this.list[0].IsApprovalNoteRequired === 'True'
      },

      atLeastOneItemIsInvoice() {
        return this.list && this.list.some(item => item.NeedsApproval.indexOf('INV') === 0)
      },

      filteredList() {
        return this.list.filter(item => {
          if (item.Type === 'Funds Request') {
            const amountWithoutSymbols = item.Amount.replace(/(USD|,)/g, '')
            const budgetBalanceWithoutSymbols = item.BudgetBalance.replace(/(USD|,)/g, '')
            return Number(amountWithoutSymbols) <= Number(budgetBalanceWithoutSymbols)
          }
          return true
        })
      }
    },

    methods: {
      isFirstItemFundsRequest(item) {
        if (item && item.Type && item.Type === 'Funds Request') {
          const amountWithoutSymbols = item.Amount.replace(/(USD|,)/g, '')
          const budgetBalanceWithoutSymbols = item.BudgetBalance.replace(/(USD|,)/g, '')
          return Number(amountWithoutSymbols) <= Number(budgetBalanceWithoutSymbols)
        }
        return true
      },

      onApprovalNoteChange() {
        if (this.reasonError && this.valid()) {
          this.reasonError = false
        }
      },

      valid() {
        if (this.atLeastOneItemIsInvoice && this.isReasonRequired && (!this.reason || !this.reason.trim())) {
          return false
        }
        return true
      },

      handleClose() {
        if (this.loading) return
        this.$emit('close')
      },

      approve() {
        if (this.loading) return
        if (this.valid()) {
          this.$emit('approve', this.reason)
        } else {
          this.reasonError = true
        }
      },

      getEndpoint() {
        if (this.cardApproval) {
          return this.api.$.evedpaycard.approveOrReject
        } else if (this.envelopeApproval) {
          return this.api.$.evedpaycard.approveOrRejectEnvelope
        } else {
          return this.submitEndpoint
        }
      }
    },

    components: { itemsList, userInfo }
  }
</script>

<style lang="scss" scoped>

.bottom-row.bottom-row.bottom-row.bottom-row {
  margin-left: -15px;
}

.request-funds-approve-container {
    width: 100%;
}

.request-funds-validation {
    align-items: left;
    justify-content: flex-start;
}

</style>



// WEBPACK FOOTER //
// src/components/_modules/Dashboard/widgets/ApprovalNeeded/approve-dialog.vue